import ToastManager from './ToastManager';
export const initToast = () => {
    window.Toast = new ToastManager();
};
initToast();
